<script setup>
import { cn } from "@/shared/lib/utils";
const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  isCollapsed: { type: Boolean, default: false },
});
</script>

<template>
  <div
    data-slot="sidebar-footer"
    :class="cn('flex flex-col', isCollapsed ? '' : 'gap-2', props.class)"
  >
    <slot />
  </div>
</template>
